module.exports = __webpack_public_path__ + "static/img/empty-study.5b02e490.png";